import { VStack, HStack, Text, Button } from "@chakra-ui/react"
import { FaLinkSlash } from "react-icons/fa6"
import Link from "@hydrologiq/shared/components/Link"
import type { AssetAssignment } from "@hydrologiq/gql-experience/graphql"

export interface CurrentAssignmentDisplayProps {
  assignment: AssetAssignment
  customerName: string
  siteName: string
  systemName?: string
  customerId: string
  siteId: string
  systemId?: string
  onDeactivate: () => void
}

/**
 * Displays the current active assignment details (customer, site, and optionally system)
 * with navigation links and a "Remove current assignment" button.
 *
 * Links navigate to the respective customer, site, or system views.
 * The remove button triggers the deactivation flow via onDeactivate callback.
 */
export function CurrentAssignmentDisplay({
  customerName,
  siteName,
  systemName,
  customerId,
  siteId,
  systemId,
  onDeactivate,
}: CurrentAssignmentDisplayProps) {
  return (
    <VStack align="start" gap={4}>
      <VStack align="start" gap={2}>
        <HStack gap={2}>
          <Text fontSize="sm" fontWeight="medium" color="fg.muted" minW="80px">
            Customer:
          </Text>
          {customerId ? (
            <Link href={`/customers/${customerId}`} variant="primary">
              {customerName}
            </Link>
          ) : (
            <Text fontSize="sm">{customerName}</Text>
          )}
        </HStack>

        <HStack gap={2}>
          <Text fontSize="sm" fontWeight="medium" color="fg.muted" minW="80px">
            Site:
          </Text>
          {siteId && customerId ? (
            <Link href={`/customers/${customerId}/sites/${siteId}`} variant="primary">
              {siteName}
            </Link>
          ) : (
            <Text fontSize="sm">{siteName}</Text>
          )}
        </HStack>

        {systemName && systemId && (
          <HStack gap={2}>
            <Text fontSize="sm" fontWeight="medium" color="fg.muted" minW="80px">
              System:
            </Text>
            <Link href={`/systems/${systemId}`} variant="primary">
              {systemName}
            </Link>
          </HStack>
        )}
      </VStack>

      <Button
        size="sm"
        variant="warning"
        onClick={onDeactivate}
      >
        <FaLinkSlash />
        Remove current assignment
      </Button>
    </VStack>
  )
}

export default CurrentAssignmentDisplay
